<template>
	<div class="app__card">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'UiCard',
};
</script>
